const stripNonUnicode = string => (string && typeof string === 'string' ?
  string.replace(/[^\x20-\x7E\n\r]/g, '')
  : string);

export default stripNonUnicode;



// WEBPACK FOOTER //
// ./src/utils/stripNonUnicode.js